/**
 * Helpers para seleção de opções (DataList, Select, Autocomplete)
 * Funções puras, reutilizáveis em todo o sistema.
 */

/**
 * Normaliza string para comparação
 */
export const normalize = (value = '') => String(value).trim().toLowerCase();

/**
 * Retorna opção cujo campo "descricao" seja exatamente igual ao texto digitado
 */
export const findExactOptionByDescricao = ({ options = [], typedValue = '' }) => {
    const v = normalize(typedValue);

    return options.find((opt) => normalize(opt?.descricao) === v) || null;
};

/**
 * Retorna opção pelo ID
 */
export const findOptionById = ({ options = [], id }) => {
    return options.find((opt) => String(opt?.id) === String(id)) || null;
};

/**
 * Verifica se texto digitado corresponde exatamente a uma opção
 */
export const isExactMatch = ({ options = [], typedValue = '' }) => {
    return !!findExactOptionByDescricao(options, typedValue);
};
